import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessrIndexStatus: 'idle',
    startProcessrIndexError: undefined as any,
    loadUserParamsProcessrIndexStatus: 'idle',
    loadUserParamsProcessrIndexError: undefined as any,

    processrIndexList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false
}
export const startProcessrIndex = createAsyncThunk('processrIndexSlice/startProcessrIndex', async (processrIndex: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/StartProcessrIndex/`


    const res = await client.post(url, prepareData(processrIndex))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { job_id: res.data.job_id }
        }
    } else {  // backend response
        return res.data
    }
})
export const loadUserParamsProcessrIndex = createAsyncThunk('processrIndexSlice/loadUserParamsProcessrIndex', async (_, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/LoadUserParamsProcessrIndex/`


    const res = await client.get(
        url,
        {
        })

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return res.data.data
        }
    } else {  // backend response
        return res.data
    }
})

const ProcessrIndexSlice = createSlice({
    name: 'processrIndexSlice',
    initialState,
    reducers: {
        resetstartProcessrIndex: (state) => {
            state.job = undefined
            state.startProcessrIndexError = undefined
        },
        resetstartProcessrIndexError: (state) => {
            state.startProcessrIndexError = undefined
        },
        resetloadUserParamsProcessrIndex: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessrIndexError = undefined
        },
        resetloadUserParamsProcessrIndexError: (state) => {
            state.loadUserParamsProcessrIndexError = undefined
        },
        removeFromProcessrIndexListById: (state, action) => {
            state.processrIndexList = state.processrIndexList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        preloadData: (state, action) => {
            state.processrIndexList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessrIndexStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processrIndexList = []
            state.startProcessrIndexStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessrIndex.pending, (state) => {
            state.startProcessrIndexStatus = 'pending'
            state.startProcessrIndexError = undefined
        })
        builder.addCase(startProcessrIndex.fulfilled, (state, action) => {
            state.startProcessrIndexStatus = 'idle'


            state.job = action.payload
        })
        builder.addCase(startProcessrIndex.rejected, (state, action) => {
            state.startProcessrIndexStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessrIndexError = action.error.message
            } else {
                state.startProcessrIndexError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessrIndex.pending, (state) => {
            state.loadUserParamsProcessrIndexStatus = 'pending'
            state.loadUserParamsProcessrIndexError = undefined
        })
        builder.addCase(loadUserParamsProcessrIndex.fulfilled, (state, action) => {
            state.loadUserParamsProcessrIndexStatus = 'idle'


            state.defaultValues = action.payload
        })
        builder.addCase(loadUserParamsProcessrIndex.rejected, (state, action) => {
            state.loadUserParamsProcessrIndexStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessrIndexError = action.error.message
            } else {
                state.loadUserParamsProcessrIndexError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessrIndex,
    resetstartProcessrIndexError,
    resetloadUserParamsProcessrIndex,
    resetloadUserParamsProcessrIndexError,
    removeFromProcessrIndexListById,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    preloadData,
    clearPreloadedData,
} = ProcessrIndexSlice.actions
export default ProcessrIndexSlice.reducer
